module.exports = __webpack_public_path__ + "static/media/event.5d164b9a.png";